import React from 'react'
import styled from 'styled-components'
import { Col } from 'react-styled-flexboxgrid-tmp'

export const _ListingPreview = styled((({ noMargin, ...props }) => <Col {...props} />))`
  position: relative;
  padding: 0 5px;
  margin-bottom: 10px;
  ${(props) => (props.noMargin && 'margin: 0;')}
`
